export interface IGeoCoordinates {
  latitude: number;
  longitude: number;
}
